import {Wrapper, VideoContainer, StyledIframe} from './Video.styled';

const Video = ({ videoId }) => (
  <Wrapper>
    <VideoContainer id="about-us">
      <StyledIframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </VideoContainer>
  </Wrapper>
);

export default Video;